export enum SolubilityObjectType {
    Solvent = 0,
    Polymer = 1,
    Mixture = 2
}
